/** 
 * Задержка перед очисткой данных слайдера после его закрытия (в миллисекундах).
 * Используется для ожидания завершения анимации закрытия. (CONTEXT: Slider)
 * @type {number}
 */
export const SLIDER_ANIMATION_DURATION = 1000;

/** 
 * Высота одного элемента в списке в пикселях. (CONTEXT: Slider)
 * @type {number}
 */
export const LIST_ITEM_HEIGHT = 48;

/**
 * Максимальный размер гифки в байтах, при превышении которого она считается «статичной». (CONTEXT: Slider)
 * @type {number}
 */
export const MAX_GIF_SIZE = 2 * 1024 * 1024;

/**
 * Ширина экрана (в пикселях), ниже которой активируется адаптивный режим слайдера. (CONTEXT: Slider)
 * @type {number}
 */
export const SLIDER_ADAPTIVE_SCREEN_SIZE = 768;